import './loader.css';

function Loader() {
  return (
    <div className="container mt-5">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
